const APP_PORT = process.env.APP_PORT || '3000';

module.exports = {
  appApi: `http://localhost:${APP_PORT}`,
  pikApi: 'https://api.pik.ru',
  pikStrapi: 'https://strapi.pik.ru',
  articleApi: 'https://article.dev-service.tech',
  pikSiteProxyOtherApi: 'https://site-proxy-other.dev-service.tech'
};
